/**
 * 견적 요청 폼의 첫 배송지 처음 수량 — 받은 값(에디터·상품 상세에서 고른 수량)이 정수이고 최소 주문 수량 이상일 때만 쓰고,
 * 아니면(없음·소수·최소 미만) 최소 주문 수량으로 시작한다. 입력 칸 값이라 문자열로 돌려준다.
 */
export const startQuantity = (minOrderQty: number, initial: number | null | undefined): string =>
  initial !== null &&
  initial !== undefined &&
  Number.isSafeInteger(initial) &&
  initial >= minOrderQty
    ? String(initial)
    : String(minOrderQty);
